import { hash } from "rsvp";
import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class VpnRoute extends Route {
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "networking");
  }

  model() {
    let { project } = this.modelFor("organization");
    return hash({
      project,
      vpnUsers: project.get("vpnUsers"),
    });
  }
}
